/* ==========================================================================
   roleta-premios.js — Roleta de prêmios da Clásico
   --------------------------------------------------------------------------
   Lê a configuração de window.ROLETA_CONFIG, montada em
   snippets/roleta-premios.liquid a partir das settings do personalizador.

   DECISÕES QUE NÃO SÃO ÓBVIAS, para ninguém "simplificar" de volta ao bug:

   1. NENHUMA FATIA TEM CHANCE ZERO. As porcentagens vêm do personalizador e
      podem ser tão pequenas quanto 0,01 — uma peça em dez mil giros é um
      prêmio raro, e raro é legítimo. Zero não: a fatia continuaria na tela
      prometendo algo que nunca sai, e o valor fica legível no view-source.
      Por isso lerPct() repõe um piso mínimo em vez de aceitar 0.

   2. O PRÊMIO É SORTEADO ANTES DA ANIMAÇÃO e a rotação é calculada para parar
      nele. O contrário — girar e ver onde para — depende do arredondamento do
      navegador e desalinha o que foi salvo do que o cliente enxerga.

   3. ESTADO EM COOKIE **E** localStorage. Um recarregar comum não devolve o
      giro. Aba anônima devolve, e não há como impedir isso num tema sem
      servidor: a trava real é o limite de uso do cupom no admin da Shopify.
      Está documentado no LEIA-ME e não deve ser vendido como à prova de nada.

   4. AS PEÇAS VÊM DO LIQUID, escolhidas uma a uma no personalizador. Título,
      foto e preço saem do próprio produto — mesma fonte do carrinho — e a
      roleta abre sem requisição nenhuma. Nunca raspar do DOM: o preço e a
      foto têm de ser os da peça sorteada, não os do primeiro card da página.
   ========================================================================== */

(function () {
  "use strict";

  var CFG = window.ROLETA_CONFIG;
  if (!CFG || !CFG.ativo) return;

  var CHAVE = "clasico_roleta_v2";
  var FATIAS = 9;
  var GRAU_FATIA = 360 / FATIAS;
  var CENTRO = 200;
  var RAIO = 190;

  // As três cores da Clásico, no ciclo das 9 fatias: laranja, preto, branco.
  // São as mesmas da faixa do topo e da logo. O texto de cada fatia é
  // escolhido pelo contraste medido, não pelo gosto:
  //   preto sobre laranja ...... 5,86:1
  //   branco sobre preto ...... 18,71:1
  //   preto sobre branco gelo .. 17,57:1
  // Branco sobre o laranja da marca dá 3,35:1 e reprova — por isso o texto
  // da fatia laranja é escuro.
  var CORES = [
    { fundo: "#f4581f", texto: "#0b0b0d" },
    { fundo: "#121214", texto: "#ffffff" },
    { fundo: "#f2f2f2", texto: "#0b0b0d" }
  ];

  var estado = null;
  var premios = [];
  var girando = false;
  var anguloAtual = 0;
  var audio = null;
  var elModal, elFab, elDisco, elHub, elPonteiro, elCorpo;

  /* ======================================================================
     Persistência
     ====================================================================== */

  function lerCookie(nome) {
    var partes = ("; " + document.cookie).split("; " + nome + "=");
    if (partes.length !== 2) return null;
    try { return decodeURIComponent(partes.pop().split(";").shift()); }
    catch (e) { return null; }
  }

  function gravarCookie(nome, valor, dias) {
    var d = new Date();
    d.setTime(d.getTime() + dias * 864e5);
    document.cookie = nome + "=" + encodeURIComponent(valor) +
      ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }

  function carregarEstado() {
    var cru = lerCookie(CHAVE);
    if (!cru) { try { cru = localStorage.getItem(CHAVE); } catch (e) { cru = null; } }
    if (!cru) return novoEstado();
    try {
      var e = JSON.parse(cru);
      // Sessão vencida: o prêmio valia para aquela compra, não para sempre.
      if (!e.ts || Date.now() - e.ts > CFG.validadeDias * 864e5) return novoEstado();
      return e;
    } catch (err) { return novoEstado(); }
  }

  function novoEstado() {
    return { girou: false, extras: 0, premio: null, ts: Date.now() };
  }

  function salvarEstado() {
    var txt = JSON.stringify(estado);
    gravarCookie(CHAVE, txt, CFG.validadeDias);
    try { localStorage.setItem(CHAVE, txt); } catch (e) { /* modo privado: o cookie basta */ }
  }

  // Nome da peça reduzido ao que identifica: "Camisa adidas Inter Miami
  // 2025/26 I" vira "Inter Miami". O título inteiro não cabe no raio de uma
  // fatia, e o que interessa ao cliente é o time.
  function nomeCurto(titulo) {
    var t = String(titulo || "").trim();
    var corta = [
      /^(camisas?|blusas?|conjuntos?|shorts|jaquetas?|bon[ée]s?|bolas?|patch|mochilas?|cal[çc]as?|meias?|vestidos?|kits?|chuteiras?|agasalhos?|regatas?)\s+/i,
      /^(feminina|feminino|infantil|masculina|masculino|de treino)\s+/i,
      /^(adidas|nike|puma|umbro|kappa|mizuno|new balance|castore|macron|joma)\s+/i
    ];
    var antes;
    do {
      antes = t;
      for (var i = 0; i < corta.length; i++) t = t.replace(corta[i], "");
    } while (t !== antes && t);

    // Ano e palavras de versão saem ANTES do numeral romano: se o numeral
    // for removido primeiro, "Japão 2026/27 I Jogador" perde o ano, tira o
    // "Jogador" e fica com o "I" órfão no fim.
    t = t.replace(/\b(19|20)\d{2}([/-]\d{2,4})?\b/g, "")
         // (^|\s)…(?=\s|$) em vez de \b: o \b do JavaScript trata acento como
         // não-letra, então \bretrô\b nunca casa e "Retrô" sobrava no rótulo.
         .replace(/(^|\s)(torcedor|jogador|player|retr[oô]|vers[ãa]o|oficial|licenciado|vintage|home|away|third|masculina|feminina|infantil|treino|com patroc[íi]nios?)(?=\s|$)/gi, " ")
         // Numeral do uniforme em QUALQUER posição, não só no fim: em
         // "Inter Miami III 10 Messi" ele fica no meio e sobrava na fatia,
         // espremendo a fonte a 7,8px.
         .replace(/\b(I{1,3}|IV|VI{0,3})\b/g, "")
         .replace(/\bn[.°ºo]*\s*\d+\b/gi, "")
         .replace(/\b\d{1,3}\b/g, "")
         .replace(/\s*[-–|]+\s*$/, "")
         // Travessão que ficou solto entre as duas metades depois de a
         // segunda sair ("Palmeiras – Treino" -> "Palmeiras –").
         .replace(/\s+[-–|]+\s+/g, " ")
         .replace(/\s{2,}/g, " ").trim();

    if (!t) t = String(titulo || "").trim();
    if (t.length > 13) {
      var espaco = t.lastIndexOf(" ", 13);
      t = (espaco > 5 ? t.slice(0, espaco) : t.slice(0, 12));
      // O corte pode terminar num separador ("Barcelona -"), que fica feio
      // colado nas reticências.
      t = t.replace(/[\s\-–—|,.:]+$/, "") + "…";
    }
    return t;
  }


  /* ======================================================================
     Montagem dos prêmios
     ====================================================================== */

  function montarPremios() {
    // As 9 fatias já vêm prontas e na ordem do snippet Liquid. Aqui só se
    // traduz o que o personalizador escreveu para o que o desenho precisa.
    return CFG.fatias.map(function (f) {
      var ehProduto = f.tipo === "produto" && f.produto;
      return {
        tipo: f.tipo,
        pct: lerPct(f.pct),
        // A peça leva o próprio nome na fatia; "grátis" diz o que se ganha.
        rotulo: ehProduto ? (nomeCurto(f.produto.titulo) || "SURPRESA")
                          : (f.rotulo || "PRÊMIO"),
        sub: ehProduto ? "grátis" : (f.sub || ""),
        codigo: f.codigo || "",
        descricao: f.descricao || "",
        exigePerso: !!f.exigePerso,
        produto: f.produto || null
      };
    });
  }

  function lerPct(v) {
    // Vem como texto do personalizador, e brasileiro digita vírgula.
    var n = parseFloat(String(v == null ? "" : v).replace(",", "."));
    // Chance zero deixaria a fatia visível e inalcançável. O piso é bem
    // menor que qualquer valor útil: uma em um milhão ainda é uma em um
    // milhão, mas não é nunca.
    if (!isFinite(n) || n <= 0) return 0.0001;
    return n;
  }

  function sortearPremio() {
    // As porcentagens não precisam somar 100: normaliza-se pelo total, que
    // é o que permite ao lojista mexer numa fatia sem recalcular as outras.
    var total = premios.reduce(function (s, p) { return s + p.pct; }, 0);
    var alvo = Math.random() * total;
    var acum = 0;
    for (var i = 0; i < premios.length; i++) {
      acum += premios[i].pct;
      if (alvo < acum) return i;
    }
    return premios.length - 1;
  }

  function avisarChances() {
    // A soma real no console ajuda a conferir a configuração sem abrir o
    // código: 40+25+20+14,95+5×0,01 fecha 100.
    var total = premios.reduce(function (s, p) { return s + p.pct; }, 0);
    var linhas = premios.map(function (p) {
      return "  " + (p.pct / total * 100).toFixed(3) + "%  " + p.rotulo;
    });
    console.info("[roleta] chances reais (soma digitada: " + total.toFixed(2) + "%)\n" + linhas.join("\n"));
  }

  /* ======================================================================
     Desenho da roleta (SVG)
     ====================================================================== */

  // Faixa radial onde o rótulo pode viver: fora do miolo e antes da
  // miniatura ou da borda.
  //
  // O limite interno é MEDIDO do hub, não fixo: ele é uma porcentagem do
  // disco e muda com a tela (22% no desktop, menos no celular). Com o valor
  // cravado em 64, a faixa ficava curta demais no celular e o ajuste
  // automático espremia "grátis" até 5,1px — ilegível.
  var LIM_INTERNO_PADRAO = 64;

  function limiteInterno() {
    if (!elHub || !elDisco) return LIM_INTERNO_PADRAO;
    var larguraDisco = elDisco.getBoundingClientRect().width;
    var larguraHub = elHub.getBoundingClientRect().width;
    if (!larguraDisco || !larguraHub) return LIM_INTERNO_PADRAO;
    // raio do hub em unidades do viewBox, mais a sombra dele e uma folga
    var raio = (larguraHub / 2) * (400 / larguraDisco);
    return Math.ceil(raio + 13 * (400 / larguraDisco) + 4);
  }

  function limiteExterno(temFoto) {
    return temFoto ? 148 : 186;   // a miniatura ocupa de 152 a 188
  }

  // Respiro que fica de cada lado do rótulo dentro da faixa. Sem isto o
  // texto longo ia de ponta a ponta e encostava no miolo e na borda. Nas
  // fatias com foto a faixa é bem mais curta, e 9 de cada lado consumia o
  // que o nome da peça precisava.
  function respiro(temFoto) { return temFoto ? 6 : 9; }

  // Encaixa cada rótulo na sua faixa radial e o centraliza nela.
  //
  // DENTRO DESTE GRUPO O EIXO X CORRE AO LONGO DO RAIO — é o que o
  // translate+rotate do transform faz. Por isso o getBBox() do grupo dá
  // direto a extensão radial do bloco inteiro, com as duas linhas juntas,
  // sem precisar compor matriz nenhuma.
  //
  // Medir em vez de calcular importa: a posição teórica do texto e a real
  // divergiam ~6 unidades (baseline, métrica da fonte), e o bloco ficava
  // com 16 de sobra para o miolo e 3 para a borda — visivelmente torto.
  function ajustarTextos(svg) {
    var interno = limiteInterno();
    var escala = elDisco.getBoundingClientRect().width / 400 || 1;
    // Abaixo disto ninguém lê. Calibrado no aparelho: a 8,5 o nome inteiro
    // virava "Barcelo…" e a 7,8 ainda saía "FC Barc…" numa tela de 360.
    // Num celular 3x, 7,2 são 21 pixels físicos — pequeno, mas legível, e
    // o nome inteiro comunica mais que meio ponto de corpo a mais.
    var MINIMO_PX = 7.2;
    var grupos = svg.querySelectorAll("g[data-rp-texto]");

    for (var i = 0; i < grupos.length; i++) {
      var g = grupos[i];
      var comFoto = g.getAttribute("data-foto") === "1";
      var disponivel = limiteExterno(comFoto) - interno - respiro(comFoto) * 2;
      var principal = g.querySelector("text");

      // 1ª tentativa: encolher o bloco inteiro até caber.
      var fator = encaixar(g, disponivel);

      // 2ª: no celular a faixa é curta e o bloco de duas linhas só cabe em
      // corpo ilegível. A segunda linha é a primeira a sair — ela repete o
      // que a tela de resultado já diz por extenso.
      if (fonteFinal(principal) * escala < MINIMO_PX && g.children.length > 1) {
        while (g.children.length > 1) g.removeChild(g.lastChild);
        principal.removeAttribute("dy");
        restaurar(g);
        fator = encaixar(g, disponivel);
      }

      // 3ª: ainda pequeno? corta o rótulo letra a letra em vez de diminuir
      // mais. "CORINTHIANS…" legível vale mais que "CORINTHIANS…" borrado.
      var texto = principal.textContent;
      while (fonteFinal(principal) * escala < MINIMO_PX && texto.replace(/…$/, "").length > 4) {
        texto = texto.replace(/…$/, "").slice(0, -1);
        principal.textContent = texto + "…";
        restaurar(g);
        encaixar(g, disponivel);
      }

      centralizar(g);
    }
  }

  function fonteFinal(texto) {
    return parseFloat(texto.style.fontSize) ||
           parseFloat(window.getComputedStyle(texto).fontSize) || 14;
  }

  function restaurar(g) {
    var ts = g.querySelectorAll("text");
    for (var i = 0; i < ts.length; i++) ts[i].style.fontSize = "";
  }

  function encaixar(g, disponivel) {
    var bb = g.getBBox();
    if (bb.width <= disponivel) return 1;
    var fator = disponivel / bb.width;
    var ts = g.querySelectorAll("text");
    for (var i = 0; i < ts.length; i++) {
      var atual = parseFloat(window.getComputedStyle(ts[i]).fontSize) || 14;
      ts[i].style.fontSize = (atual * fator).toFixed(2) + "px";
    }
    return fator;
  }

  // O centro do bloco tem de cair em x local 0, que é onde o translate já o
  // colocou no meio da faixa. Medir em vez de calcular: a posição teórica e
  // a real divergiam ~6 unidades por causa da métrica da fonte, e o bloco
  // ficava visivelmente torto dentro da fatia.
  function centralizar(g) {
    var base = g.getAttribute("transform").replace(/\s*translate\([^)]*\)\s*$/, "");
    g.setAttribute("transform", base);
    var bb = g.getBBox();
    var desvio = bb.x + bb.width / 2;
    if (Math.abs(desvio) > 0.3) {
      g.setAttribute("transform", base + " translate(" + (-desvio).toFixed(2) + ",0)");
    }
  }

  function mod360(g) {
    // O % do JavaScript devolve negativo para entrada negativa: -40 % 360 é
    // -40, não 320. Sem normalizar, o disco giraria para trás.
    return ((g % 360) + 360) % 360;
  }

  function ponto(anguloGraus, raio) {
    // 0° = topo (12h), sentido horário — mesma referência do ponteiro.
    var r = (anguloGraus - 90) * Math.PI / 180;
    return [CENTRO + raio * Math.cos(r), CENTRO + raio * Math.sin(r)];
  }

  function desenharDisco() {
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 400 400");
    svg.setAttribute("aria-hidden", "true");

    var defs = document.createElementNS(ns, "defs");
    svg.appendChild(defs);

    premios.forEach(function (premio, i) {
      var ini = i * GRAU_FATIA - GRAU_FATIA / 2;
      var fim = ini + GRAU_FATIA;
      var cor = CORES[i % CORES.length];
      var a = ponto(ini, RAIO), b = ponto(fim, RAIO);

      var fatia = document.createElementNS(ns, "path");
      fatia.setAttribute("d",
        "M" + CENTRO + "," + CENTRO +
        " L" + a[0].toFixed(2) + "," + a[1].toFixed(2) +
        " A" + RAIO + "," + RAIO + " 0 0 1 " + b[0].toFixed(2) + "," + b[1].toFixed(2) + " Z");
      fatia.setAttribute("fill", cor.fundo);
      fatia.setAttribute("stroke", "rgba(0,0,0,.28)");
      fatia.setAttribute("stroke-width", "1.5");
      svg.appendChild(fatia);

      var meio = i * GRAU_FATIA;
      var grupo = document.createElementNS(ns, "g");
      // Gira o conteúdo junto com a fatia e o deixa de pé, lendo do centro
      // para fora.
      grupo.setAttribute("transform", "rotate(" + meio + " " + CENTRO + " " + CENTRO + ")");

      var temFoto = premio.tipo === "produto" && premio.produto;

      if (temFoto) {
        var rFoto = 170, raioFoto = 15;
        var clipId = "rp-clip-" + i;
        var clip = document.createElementNS(ns, "clipPath");
        clip.setAttribute("id", clipId);
        var circ = document.createElementNS(ns, "circle");
        circ.setAttribute("cx", CENTRO);
        circ.setAttribute("cy", CENTRO - rFoto);
        circ.setAttribute("r", raioFoto);
        clip.appendChild(circ);
        defs.appendChild(clip);

        var aro = document.createElementNS(ns, "circle");
        aro.setAttribute("cx", CENTRO);
        aro.setAttribute("cy", CENTRO - rFoto);
        aro.setAttribute("r", raioFoto + 2.5);
        aro.setAttribute("fill", "rgba(255,255,255,.92)");
        grupo.appendChild(aro);

        var img = document.createElementNS(ns, "image");
        img.setAttributeNS("http://www.w3.org/1999/xlink", "href", premio.produto.foto);
        img.setAttribute("href", premio.produto.foto);
        img.setAttribute("x", CENTRO - raioFoto);
        img.setAttribute("y", CENTRO - rFoto - raioFoto);
        img.setAttribute("width", raioFoto * 2);
        img.setAttribute("height", raioFoto * 2);
        img.setAttribute("preserveAspectRatio", "xMidYMid slice");
        img.setAttribute("clip-path", "url(#" + clipId + ")");
        grupo.appendChild(img);
      }

      // TEXTO RADIAL, correndo ao longo do raio.
      //
      // A primeira versão escrevia o rótulo na horizontal, perto do eixo, e
      // os textos se sobrepunham: numa fatia de 40°, a largura útil a 76 do
      // centro é só 52 — "GIRE DE NOVO" precisa do dobro. Ao longo do raio há
      // espaço para qualquer rótulo.
      //
      // O RAIO MÍNIMO É 70, NÃO 58: o hub tem raio 55,7 mais 8,6 de sombra,
      // e o "1" de "15% OFF" ficava escondido atrás dele — a fatia anunciava
      // 5% OFF. Rótulo de preço encoberto é erro de preço, não de layout.
      //
      // Com translate para o ponto do raio e text-anchor no meio, a rotação
      // decide só o sentido da leitura: -90 lê do centro para a borda, +90 ao
      // contrário. Na metade esquerda da roleta o texto sairia de cabeça para
      // baixo, então lá ele é invertido.
      // O texto fica centrado no meio do espaço que lhe cabe, e depois
      // ajustarTextos() encolhe a fonte se ainda assim faltar largura.
      var rMeio = (limiteInterno() + limiteExterno(temFoto)) / 2;

      // A direção de escrita, depois das duas rotações, é (sen θ, −cos θ). O
      // texto só sai de cabeça para baixo quando a componente horizontal é
      // negativa, isto é, θ acima de 180° — não acima de 90°, que era o corte
      // errado da primeira versão e deixava "PERSONALIZA" espelhado a 280°.
      var inverter = meio > 180;

      var grupoTexto = document.createElementNS(ns, "g");
      grupoTexto.setAttribute("data-rp-texto", "1");
      grupoTexto.setAttribute("data-foto", temFoto ? "1" : "0");
      // Guardados para reorientarTextos(): depois que o disco gira, o ângulo
      // efetivo de cada fatia muda e a conta de inverter tem de ser refeita.
      grupoTexto.setAttribute("data-meio", String(meio));
      grupoTexto.setAttribute("data-r", String(rMeio));
      grupoTexto.setAttribute("transform",
        "translate(" + CENTRO + "," + (CENTRO - rMeio) + ") rotate(" + (inverter ? 90 : -90) + ")");

      var texto = document.createElementNS(ns, "text");
      texto.setAttribute("x", "0");
      texto.setAttribute("y", "0");
      texto.setAttribute("text-anchor", "middle");
      texto.setAttribute("dominant-baseline", "middle");
      texto.setAttribute("fill", cor.texto);
      texto.setAttribute("class", temFoto ? "rp-fatia-texto rp-fatia-texto--curto" : "rp-fatia-texto");
      // Sem sub, o rótulo fica centrado no raio; com sub, sobe para abrir espaço.
      if (premio.sub) texto.setAttribute("dy", temFoto ? "-4" : "-4.5");
      texto.textContent = premio.rotulo;
      grupoTexto.appendChild(texto);

      // A segunda linha cabe até nas fatias com foto: o que falta ali é
      // espaço RADIAL para rótulos longos, não espaço entre as linhas — a
      // fatia tem ~68 unidades de largura na altura do texto.
      if (premio.sub) {
        var sub = document.createElementNS(ns, "text");
        sub.setAttribute("x", "0");
        sub.setAttribute("y", "0");
        sub.setAttribute("dy", temFoto ? "7" : "8");
        sub.setAttribute("text-anchor", "middle");
        sub.setAttribute("dominant-baseline", "middle");
        sub.setAttribute("fill", cor.texto);
        sub.setAttribute("class", temFoto ? "rp-fatia-sub rp-fatia-sub--curto" : "rp-fatia-sub");
        sub.textContent = premio.sub;
        grupoTexto.appendChild(sub);
      }

      grupo.appendChild(grupoTexto);
      svg.appendChild(grupo);
    });

    elDisco.innerHTML = "";
    elDisco.appendChild(svg);
    // Só depois de estar no documento o getBBox devolve medida de verdade.
    ajustarTextos(svg);
  }

  function desenharLampadas(aro) {
    var n = 18;
    for (var i = 0; i < n; i++) {
      var ang = (i / n) * 360;
      var l = document.createElement("span");
      l.className = "rp-lampada";
      l.style.left = (50 + 49.5 * Math.cos((ang - 90) * Math.PI / 180)) + "%";
      l.style.top = (50 + 49.5 * Math.sin((ang - 90) * Math.PI / 180)) + "%";
      l.style.animationDelay = (i * 0.072) + "s";
      aro.appendChild(l);
    }
  }

  /* ======================================================================
     Som — tick a cada fatia, sem arquivo de áudio
     ====================================================================== */

  function tick() {
    if (!CFG.som) return;
    try {
      if (!audio) {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        audio = new AC();
      }
      var osc = audio.createOscillator();
      var gan = audio.createGain();
      osc.type = "triangle";
      osc.frequency.value = 980;
      gan.gain.setValueAtTime(0.06, audio.currentTime);
      gan.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.06);
      osc.connect(gan); gan.connect(audio.destination);
      osc.start(); osc.stop(audio.currentTime + 0.06);
    } catch (e) { /* som é enfeite: nunca pode derrubar o giro */ }
  }

  function fanfarra() {
    if (!CFG.som || !audio) return;
    try {
      [523, 659, 784, 1046].forEach(function (hz, i) {
        var osc = audio.createOscillator();
        var gan = audio.createGain();
        osc.type = "sine";
        osc.frequency.value = hz;
        var t = audio.currentTime + i * 0.1;
        gan.gain.setValueAtTime(0.0001, t);
        gan.gain.exponentialRampToValueAtTime(0.12, t + 0.02);
        gan.gain.exponentialRampToValueAtTime(0.0001, t + 0.34);
        osc.connect(gan); gan.connect(audio.destination);
        osc.start(t); osc.stop(t + 0.34);
      });
    } catch (e) { /* idem */ }
  }

  /* ======================================================================
     Giro
     ====================================================================== */

  function girar() {
    if (girando) return;
    if (estado.girou && estado.extras <= 0) return;

    girando = true;
    elHub.disabled = true;
    elHub.textContent = "...";

    var indice = sortearPremio();
    var premio = premios[indice];

    // GEOMETRIA — errar aqui faz a roleta parar numa fatia e anunciar outra.
    //
    // A fatia i tem o centro em (i * 40°) a partir do topo, no sentido
    // horário, que é o mesmo sentido do rotate() do CSS. O ponteiro está
    // fixo em 0°. Para a fatia i chegar ao ponteiro, o disco precisa
    // terminar em -(i * 40°), módulo 360.
    var desvio = (Math.random() - 0.5) * (GRAU_FATIA - 10);
    var voltas = 6 + Math.floor(Math.random() * 3);
    var repouso = mod360(-(indice * GRAU_FATIA) + desvio);
    // O disco nunca volta: avança até o repouso e ainda dá as voltas cheias.
    var avanco = mod360(repouso - mod360(anguloAtual));
    var alvoFinal = anguloAtual + avanco + 360 * voltas;

    var dur = CFG.duracao;
    var reduzido = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduzido) dur = 400;

    elDisco.style.transition = "transform " + dur + "ms cubic-bezier(.17,.67,.14,.99)";
    // Força o reflow antes de aplicar o destino. Sem isso o navegador funde
    // as duas escritas e o disco salta sem animar.
    void elDisco.offsetWidth;
    elDisco.style.transform = "rotate(" + alvoFinal + "deg)";

    if (!reduzido) acompanharTicks(anguloAtual, alvoFinal, dur);
    anguloAtual = alvoFinal;

    setTimeout(function () {
      girando = false;
      // Antes de qualquer outra coisa: o disco já parou e os rótulos têm de
      // estar legíveis na posição final.
      reorientarTextos(alvoFinal);
      registrarPremio(premio);
      mostrarResultado(premio);
    }, dur + 220);
  }

  // A inversão é decidida na montagem, com o disco em 0°. Depois do giro o
  // disco para em qualquer ângulo, e as fatias que estavam na metade de cima
  // vão para a de baixo: cinco dos nove rótulos ficavam de cabeça para baixo
  // na tela em que o cliente mais olha. Aqui a conta é refeita com o ângulo
  // em que cada fatia REALMENTE parou.
  function reorientarTextos(rotacao) {
    var grupos = elDisco.querySelectorAll("[data-rp-texto]");
    for (var i = 0; i < grupos.length; i++) {
      var g = grupos[i];
      var meio = parseFloat(g.getAttribute("data-meio"));
      var r = parseFloat(g.getAttribute("data-r"));
      if (isNaN(meio) || isNaN(r)) continue;
      var efetivo = ((meio + rotacao) % 360 + 360) % 360;
      g.setAttribute("transform",
        "translate(" + CENTRO + "," + (CENTRO - r) + ") rotate("
          + (efetivo > 180 ? 90 : -90) + ")");
    }
  }

  function acompanharTicks(de, para, dur) {
    // Bate o ponteiro a cada fatia que cruza o topo. Segue a MESMA curva da
    // transição CSS, senão o som descola da imagem no fim do giro.
    var inicio = performance.now();
    var ultima = -1;
    function curva(t) {
      // Aproximação da cubic-bezier(.17,.67,.14,.99) usada no CSS.
      return 1 - Math.pow(1 - t, 3.4);
    }
    function passo(agora) {
      var t = Math.min(1, (agora - inicio) / dur);
      var ang = de + (para - de) * curva(t);
      var fatia = Math.floor(ang / GRAU_FATIA);
      if (fatia !== ultima) {
        ultima = fatia;
        tick();
        elPonteiro.classList.remove("rp-ponteiro--bate");
        void elPonteiro.offsetWidth;
        elPonteiro.classList.add("rp-ponteiro--bate");
      }
      if (t < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }

  function registrarPremio(premio) {
    if (premio.tipo === "degiro") {
      estado.extras = (estado.extras || 0) + 1;
      // Não marca girou: o cliente ainda tem um giro pendente.
      salvarEstado();
      return;
    }
    // Premiou: o ciclo fecha e os giros extras acumulados caem junto.
    // Sem isto, quem tirasse "gire de novo" duas vezes e depois um prêmio
    // bom ainda teria um giro sobrando — e o giro seguinte sobrescreveria
    // esse prêmio por um pior. O cliente perderia por ter tido sorte.
    estado.extras = 0;
    estado.girou = true;
    estado.premio = {
      tipo: premio.tipo,
      rotulo: premio.rotulo,
      codigo: premio.codigo,
      descricao: premio.descricao || "",
      exigePerso: !!premio.exigePerso,
      produto: premio.produto || null,
      ts: Date.now()
    };
    salvarEstado();
  }

  /* ======================================================================
     Resultado
     ====================================================================== */

  function mostrarResultado(premio) {
    if (premio.tipo === "degiro") {
      elHub.disabled = false;
      elHub.textContent = "GIRAR";
      pintarAviso('<span class="rp-barras">///</span> Boa! Você ganhou '
        + "<strong>mais um giro</strong>. Gire de novo!");
      return;
    }
    desenharFinal(premio);
    // Confete e fanfarra são para quem ganhou. Comemorar um "não foi dessa
    // vez" seria deboche.
    if (premiou(premio)) { confete(); fanfarra(); }
  }

  // Uma fatia de vitrine sem código de consolo não entrega prêmio nenhum.
  function premiou(premio) {
    return premio.tipo !== "degiro";
  }

  function desenharFinal(premio) {
    desenharPremio(premio);
  }


  function pintarAviso(html) {
    var aviso = elCorpo.querySelector(".rp-aviso");
    if (!aviso) {
      aviso = document.createElement("p");
      aviso.className = "rp-aviso rp-subtitulo";
      aviso.style.color = "#f4581f";
      elCorpo.querySelector(".rp-regras").before(aviso);
    }
    aviso.innerHTML = html;
  }

  function desenharPremio(premio) {
    var ehPeca = premio.tipo === "produto" && premio.produto;
    var destino = CFG.destino || "/";
    // Ganhou uma peça: o caminho é a página dela, já com o cupom aplicado.
    if (ehPeca) destino = "/products/" + premio.produto.handle;

    var foto = (premio.produto && premio.produto.foto)
      ? '<img class="rp-resultado__foto" src="' + escapar(premio.produto.foto) +
        '" alt="' + escapar(premio.produto.titulo) + '" width="96" height="96">'
      : '<div class="rp-resultado__icone">'
        + '<svg viewBox="0 0 56 56" width="54" height="54" aria-hidden="true" focusable="false">'
        + '<rect x="9" y="24" width="38" height="24" rx="3" fill="#f4581f"/>'
        + '<rect x="5" y="15" width="46" height="11" rx="3" fill="#ff8a4c"/>'
        + '<rect x="24" y="15" width="8" height="33" fill="#f2f2f2"/>'
        + '<ellipse cx="20" cy="11" rx="7" ry="5.4" fill="none" stroke="#f2f2f2" stroke-width="3.4"/>'
        + '<ellipse cx="36" cy="11" rx="7" ry="5.4" fill="none" stroke="#f2f2f2" stroke-width="3.4"/>'
        + '</svg></div>';

    var titulo = ehPeca ? escapar(premio.produto.titulo) : escapar(premio.rotulo);
    var texto = ehPeca
      ? "Esta peça é sua. Use o código na página dela para zerar o valor."
      : escapar(premio.descricao || "");
    if (premio.exigePerso) {
      texto = escapar(premio.descricao || "") +
        " Vale na camisa que você escolher com personalização.";
    }

    // Sem código configurado o cliente não tem como resgatar: em vez de
    // mostrar um cupom vazio, manda falar com a loja — e grita no console,
    // porque isso é erro de configuração, não do cliente.
    var temCodigo = !!premio.codigo;
    if (!temCodigo) {
      console.warn("[roleta] a fatia \"" + premio.rotulo + "\" premiou mas não tem " +
                   "código de cupom configurado no personalizador.");
    }

    // O botão passa por /discount/CODIGO, que deixa o código na sessão. O
    // abatimento, porém, só aparece no CHECKOUT: a Shopify não desconta
    // cupom de código no carrinho, e o carrinho segue mostrando o valor
    // cheio. Prometer "entra no carrinho" fazia o cliente procurar ali um
    // desconto que não ia estar.
    var avisoAuto = '<p class="rp-auto"><span aria-hidden="true">✓</span> ' +
      'O desconto entra sozinho no checkout. Não precisa digitar nada.</p>';

    // PRÊMIO QUE DEPENDE DA PERSONALIZAÇÃO: o código NÃO vai na saída.
    // Ele vale sobre qualquer item, então aplicá-lo aqui viraria desconto na
    // camisa de quem não personalizar. Quem aplica é o carrinho, no instante
    // em que uma peça com "Personalizar" entra nele.
    if (premio.exigePerso) {
      avisoAuto = '<p class="rp-auto"><span aria-hidden="true">✓</span> ' +
        'Escolha uma camisa e marque <strong>Personalizar</strong>: o desconto ' +
        'entra sozinho no checkout.</p>';
    }

    var blocoResgate;
    if (!temCodigo) {
      blocoResgate =
        '<p class="rp-resultado__desc">Fale com a gente pelo chat para retirar o prêmio.</p>' +
        '<a class="rp-botao rp-botao--calmo" href="' + escapar(destino) + '">Ver na loja</a>';
    } else {
      var href = premio.exigePerso
        ? destino
        : "/discount/" + encodeURIComponent(premio.codigo) + "?redirect=" + encodeURIComponent(destino);
      var rotuloBotao = premio.exigePerso ? "Escolher minha camisa"
                      : (ehPeca ? "Resgatar minha peça" : "Usar meu prêmio agora");
      blocoResgate =
        '<div class="rp-cupom">' +
          '<span class="rp-cupom__codigo">' + escapar(premio.codigo) + "</span>" +
          '<button type="button" class="rp-cupom__copiar">Copiar</button>' +
        "</div>" +
        avisoAuto +
        '<a class="rp-botao" href="' + href + '">' + rotuloBotao + "</a>";
    }

    elCorpo.innerHTML =
      '<div class="rp-resultado">' +
        '<p class="rp-chapeu">' + (ehPeca ? "Prêmio raro" : "Prêmio garantido") + "</p>" +
        foto +
        '<h2 class="rp-resultado__titulo">Você ganhou</h2>' +
        '<p class="rp-resultado__premio' + (ehPeca ? ' rp-resultado__premio--peca' : '') + '">' +
          titulo + "</p>" +
        '<p class="rp-resultado__desc">' + texto + "</p>" +
        blocoResgate +
        '<p class="rp-validade">' + escapar(CFG.textoValidade) + "</p>" +
      "</div>";

    var botaoCopiar = elCorpo.querySelector(".rp-cupom__copiar");
    if (botaoCopiar) {
      botaoCopiar.addEventListener("click", function () {
        copiar(premio.codigo, botaoCopiar);
      });
    }

    marcarFabResgatado();
  }

  function copiar(texto, botao) {
    function ok() {
      botao.textContent = "Copiado!";
      botao.classList.add("rp-cupom__copiar--feito");
      setTimeout(function () {
        botao.textContent = "Copiar";
        botao.classList.remove("rp-cupom__copiar--feito");
      }, 2200);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(ok).catch(function () { copiarLegado(texto, ok); });
    } else {
      copiarLegado(texto, ok);
    }
  }

  function copiarLegado(texto, ok) {
    // Safari antigo e contexto sem HTTPS não têm clipboard.writeText.
    var ta = document.createElement("textarea");
    ta.value = texto;
    ta.setAttribute("readonly", "");
    ta.style.cssText = "position:absolute;left:-9999px";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); ok(); } catch (e) { /* resta ler na tela */ }
    document.body.removeChild(ta);
  }

  function confete() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var caixa = document.createElement("div");
    caixa.className = "rp-confete";
    // Confete nas cores da marca, com um laranja claro para dar variação.
    var cores = ["#f4581f", "#ff8a4c", "#ffffff", "#c2410c", "#a8a8b0"];
    for (var i = 0; i < 46; i++) {
      var p = document.createElement("i");
      p.style.left = Math.random() * 100 + "%";
      p.style.background = cores[i % cores.length];
      p.style.animationDuration = (1.5 + Math.random() * 1.3) + "s";
      p.style.animationDelay = (Math.random() * 0.45) + "s";
      p.style.opacity = "1";
      if (i % 3 === 0) p.style.borderRadius = "50%";
      caixa.appendChild(p);
    }
    elModal.querySelector(".rp-caixa").appendChild(caixa);
    setTimeout(function () { caixa.remove(); }, 3600);
  }

  function escapar(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }


  /* ======================================================================
     Selo compacto
     ====================================================================== */

  // O selo mostra o CÓDIGO do cupom, não o nome do prêmio: é o código que o
  // cliente precisa reconhecer no carrinho e no checkout. Sem prêmio ainda,
  // vira um convite curto para girar.
  function preencherSeloCompacto() {
    if (!elFab) return;
    var mini = elFab.querySelector("[data-rp-mini]");
    var p = estado && estado.premio;
    var texto, rotuloAcessivel;

    if (p && p.codigo) {
      texto = p.codigo;
      rotuloAcessivel = "Ver meu prêmio, cupom " + p.codigo;
    } else if (p) {
      // prêmio sem código (fatia de vitrine ou cupom não configurado)
      texto = p.rotulo || "PRÊMIO";
      rotuloAcessivel = "Ver meu prêmio: " + texto;
    } else {
      texto = "GIRAR";
      rotuloAcessivel = "Abrir a roleta de prêmios";
    }

    if (mini) mini.textContent = texto;
    elFab.setAttribute("aria-label", rotuloAcessivel);
    if (p && !premiou(p)) elFab.classList.add("rp-fab--sem-premio");
  }

  // Chamado pelo X da home: em vez de sumir, o convite encolhe para o mesmo
  // selo das páginas internas. O cliente destrava a tela sem perder o acesso.
  function compactarFab() {
    var area = elFab && elFab.closest(".rp-fab-area");
    if (!area) return;
    area.classList.add("rp-fab-area--compacto");
    area.setAttribute("data-rp-modo", "compacto");
    preencherSeloCompacto();
    var x = document.getElementById("rp-fab-fechar");
    if (x) x.hidden = true;
  }

  /* ======================================================================
     Abrir e fechar
     ====================================================================== */

  var focoAnterior = null;

  function abrir() {
    focoAnterior = document.activeElement;
    elModal.hidden = false;
    document.body.style.overflow = "hidden";

    // Fechar e reabrir no meio de um giro (ESC, ou o X) remontaria o disco
    // por baixo da animação em curso: o prêmio ainda seria registrado pelo
    // temporizador, mas sobre uma roleta redesenhada e parada. Reabrir
    // apenas mostra o giro que já está rolando.
    if (girando) return;

    if (estado.girou && estado.extras <= 0 && estado.premio) {
      desenharFinal(estado.premio);
      return;
    }

    // Sem espera de rede: as peças vêm do Liquid, já no HTML da página.
    premios = montarPremios();
    avisarChances();
    desenharDisco();
    elHub.disabled = false;
    elHub.textContent = "GIRAR";
    elHub.focus();
  }

  function fechar() {
    elModal.hidden = true;
    document.body.style.overflow = "";
    if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
  }

  function marcarFabResgatado() {
    // Fora da home não existe botão para marcar; o prêmio já está salvo.
    if (!elFab) return;
    var ganhou = estado.premio && premiou(estado.premio);
    var rotulo = ganhou ? "Ver meu prêmio" : "Você já girou";
    elFab.classList.add("rp-fab--resgatado");
    if (!ganhou) elFab.classList.add("rp-fab--sem-premio");
    var selo = elFab.querySelector(".rp-fab__selo");
    if (selo) selo.remove();
    var balao = elFab.querySelector(".rp-fab__balao");
    if (balao) balao.textContent = rotulo;
    elFab.setAttribute("aria-label", rotulo);
    // Girou pela pílula (página interna, ou depois do X da home): ela troca
    // GIRAR pelo código do cupom na hora, sem esperar recarregar.
    var area = elFab.closest(".rp-fab-area");
    if (area && area.classList.contains("rp-fab-area--compacto")) preencherSeloCompacto();
  }



  /* ======================================================================
     Regra da personalização
     ====================================================================== */

  // O cupom de personalização vale R$ 30 sobre QUALQUER item — é assim que
  // a Shopify o entrega, porque um desconto não sabe distinguir variante.
  // Sem esta regra, quem ganhasse o prêmio e não marcasse "Personalizar"
  // levaria R$ 30 de desconto na camisa, que não é o prêmio prometido.
  //
  // A peça personalizada aparece no carrinho como uma OPÇÃO de variante:
  //   options_with_values: [{name: "Personalizar Camisa (+R$ 35)",
  //                          value: "Personalizar"}]
  // O nome da opção sempre contém "personaliz"; quem decide é o VALOR.
  function temPersonalizacao(cart) {
    var itens = (cart && cart.items) || [];
    for (var i = 0; i < itens.length; i++) {
      var ops = itens[i].options_with_values || [];
      for (var j = 0; j < ops.length; j++) {
        var valor = String(ops[j].value || "").toLowerCase();
        if (valor.indexOf("personaliz") >= 0 || valor === "sim") return true;
      }
      // Cinto e suspensório: há produto em que a escolha vem por property.
      var props = itens[i].properties || {};
      if ((props["Nome"] && String(props["Nome"]).trim()) ||
          (props["Número"] && String(props["Número"]).trim())) return true;
    }
    return false;
  }

  // Grava o código na sessão SEM tirar o cliente da página: /discount/CODIGO
  // responde a um fetch e o cupom passa a valer no carrinho e no checkout.
  function aplicarCupom(codigo) {
    return fetch("/discount/" + encodeURIComponent(codigo), { redirect: "follow" })
      .then(function () { return true; })
      .catch(function () { return false; });
  }

  // Chamado a cada leitura do carrinho: se o prêmio estava esperando a
  // personalização e ela chegou, o cupom entra sozinho.
  function talvezAplicarPremioPendente(cart) {
    var p = estado && estado.premio;
    if (!p || !p.codigo || !p.exigePerso || p.aplicado) return Promise.resolve(false);
    if (!temPersonalizacao(cart)) return Promise.resolve(false);

    return aplicarCupom(p.codigo).then(function (ok) {
      if (!ok) return false;
      p.aplicado = true;
      salvarEstado();
      return true;
    });
  }

  /* ======================================================================
     Selo do cupom no carrinho
     ====================================================================== */

  // O carrinho não mostra mais nada sobre o prêmio — o aviso na tela da
  // roleta já diz que o desconto entra sozinho no checkout. O que sobra
  // aqui é só a REGRA: o cupom de personalização precisa ser aplicado no
  // instante em que uma peça personalizada entra no carrinho, porque ele
  // vale sobre qualquer item e não pode ser dado antes disso.
  function precisaDoCarrinho() {
    var p = estado && estado.premio;
    return !!(p && p.codigo && p.exigePerso && !p.aplicado);
  }

  function verificarCarrinho() {
    if (!precisaDoCarrinho()) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) return talvezAplicarPremioPendente(cart); })
      .catch(function (e) {
        // Falhar calado na tela: o carrinho segue correto sem isto, e o
        // cliente ainda pode aplicar o cupom pelo código.
        console.warn("[roleta] não consegui ler o carrinho:", e.message);
      });
  }

  function vigiarCarrinho() {
    // Só lê o carrinho quando a resposta tem uso: ou há selo para preencher
    // nesta página, ou há prêmio esperando a personalização para entrar.
    // Sem isso, toda página de toda visita gastava uma requisição para
    // descartar o resultado.
    verificarCarrinho();

    // O tema mexe no carrinho por fetch. Envolver o fetch avisa o selo em
    // qualquer caminho — drawer, página /cart, compre-junto — sem depender
    // de evento próprio do tema. A promise devolvida é a original.
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === "function" && !fetchOriginal.__rpEnvolvido) {
      var envolvido = function () {
        var p = fetchOriginal.apply(this, arguments);
        try {
          var a = arguments[0];
          var url = String((a && a.url) || a || "");
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            p.then(function () { setTimeout(verificarCarrinho, 150); })
             .catch(function () {});
          }
        } catch (e) { /* nunca atrapalhar o fetch do tema */ }
        return p;
      };
      envolvido.__rpEnvolvido = true;
      window.fetch = envolvido;
    }
  }

  /* ======================================================================
     Início
     ====================================================================== */

  function iniciar() {
    estado = carregarEstado();

    // O SELO E A REGRA DO PRÊMIO VALEM EM QUALQUER PÁGINA, mesmo onde o
    // botão não aparece. O cliente ganha na home e vai personalizar na
    // página do produto: se isto dependesse do botão existir, o cupom
    // nunca seria aplicado fora da home.
    vigiarCarrinho();

    elModal = document.getElementById("rp-modal");
    elFab = document.getElementById("rp-fab");
    if (!elModal || !elFab) return;

    // As referências do modal vêm ANTES de qualquer saída: o modo compacto
    // também abre o modal para mostrar o prêmio, e sem elCorpo definido o
    // desenho estourava "Cannot set properties of undefined".
    elDisco = elModal.querySelector(".rp-disco");
    elHub = elModal.querySelector(".rp-hub");
    elPonteiro = elModal.querySelector(".rp-ponteiro");
    elCorpo = elModal.querySelector(".rp-corpo");

    // MODO COMPACTO (páginas internas, desde 04/10/2026): a pílula aparece
    // SEMPRE, com ou sem prêmio. Sem prêmio diz GIRAR — o Liquid já a entrega
    // com esse texto, então nada pisca — e abre a roleta inteira, que gira
    // de verdade. Por isso não há mais saída antecipada aqui: até essa data
    // o compacto só ligava o modal, sem o botão de girar, e só aparecia para
    // quem já tinha prêmio.
    var area = elFab.closest(".rp-fab-area");
    var compacto = !!(area && area.getAttribute("data-rp-modo") === "compacto");
    if (compacto) preencherSeloCompacto();

    desenharLampadas(elModal.querySelector(".rp-aro"));

    if (estado.girou && estado.extras <= 0 && estado.premio) marcarFabResgatado();

    elFab.addEventListener("click", abrir);

    // Dispensar tira o convite da frente AGORA e nada mais: não é gravado em
    // lugar nenhum, então qualquer recarga ou página nova traz o botão de
    // volta. É o comportamento pedido — o X serve para destravar a tela num
    // momento de leitura, não para desistir da roleta.
    // NÃO chamar esta variável de "fechar": existe uma função fechar() no
    // módulo, e uma var de mesmo nome dentro desta função a sombreia por
    // içamento. O addEventListener("click", fechar) logo acima passava a
    // registrar undefined — o X do modal parava de fechar, sem erro nenhum
    // no console.
    var botaoDispensar = document.getElementById("rp-fab-fechar");
    if (botaoDispensar) {
      botaoDispensar.addEventListener("click", function (e) {
        e.stopPropagation();
        compactarFab();
      });
    }

    elHub.addEventListener("click", girar);
    elModal.querySelector(".rp-fechar").addEventListener("click", fechar);
    elModal.querySelector(".rp-modal__veu").addEventListener("click", fechar);

    // O tema fecha o carrinho a cada clique que cai fora de <cart-notification>.
    // Sem isto, clicar dentro da roleta fecharia o drawer por tabela.
    elModal.querySelector(".rp-caixa").addEventListener("click", function (e) {
      e.stopPropagation();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !elModal.hidden) fechar();
    });

    // Abrir sozinha é convite da home. Na página interna o cliente está
    // comprando, e o modal na cara dele atrapalharia.
    if (CFG.abrirSozinho && !estado.girou && !compacto) {
      setTimeout(function () { if (elModal.hidden) abrir(); }, CFG.abrirSozinhoSeg * 1000);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
